import {ID} from "../../../../_metronic/helpers";
import {date} from "yup";

export type TicketModel  = {
    id? : ID ,
    title? : string ,
    ticketStatus? : ticketStatus ,
    ticketStatusString : string ,
    userID? : number ,
    user? : string ,
    dataCreate? : Date ,
    dataCreateString? : string ,
    dataModified? : Date ,
    dataModifiedstring? : string ,
    tiketContents? : TicketContentModel[]
}
export type TicketContentModel = {
    id? : ID ,
    tiketId : number ,
    isAdminSide : boolean ,
    text : string ,
    fileURL : string ,
    userid : number ,
    user : string ,
    userPic?:string ,
    dataCreate : Date ,
    dataModified : Date,
    dataCreateString : string ,
    dataModifiedstring : string ,


}
export enum ticketStatus {
    IsCreated,
    IsClosed,
    IsPending,
    IsReading,
    AdminIsResponse,
}